import React, { useCallback, useContext } from 'react';
import { useAppDispatch } from '../../../store/configureStore';
import SortIcon from '@mui/icons-material/Sort';

import sortedEnum from '../../../enums/sortedEnum';
import { sessionKeyStoreEnum } from '../../../enums/sessionKeyStoreEnum';
import ButtonTextIcon from '../../../components/buttons/ButtonTextIcon';
import { SessionContext } from '../../../context';

export default function Sort() {
  const dispatch = useAppDispatch();
  const { sessionStore = {}, updateSessionStore } = useContext(SessionContext);

  const { sorted } = sessionStore;

  const checkSortedOrder = useCallback(() => {
    const newSorted =
      sorted === sortedEnum.DESCENDING ? sortedEnum.ASCENDING : sortedEnum.DESCENDING;
    updateSessionStore({ [sessionKeyStoreEnum.SORTED]: newSorted });
  }, [sorted]);

  return (
    <ButtonTextIcon
      icon={
        <span style={sorted === sortedEnum.DESCENDING ? styles.flipIcon : null}>
          <SortIcon />
        </span>
      }
      onClick={() => checkSortedOrder(dispatch)}
      tooltip="Sort"
    >
      Sort
    </ButtonTextIcon>
  );
}

const styles = {
  flipIcon: {
    transform: `scaleY(-1)`,
  },
};
